import { call, delay, select } from 'redux-saga/effects';
import { selectIsConnected, selectSocket } from '../../../state/socket/socketSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export default function* socketSubscribeSaga({ payload }){
    let isConnected = yield select(selectIsConnected);
    while (!isConnected) {
      yield delay(1000);
      isConnected = yield select(selectIsConnected);
    }
    const socket = yield select(selectSocket);
    const userCredential = yield select(selectUserCredentials)
    const { domain, user, access_token } = userCredential;

    socket.emit('subscribe', {
        bearer: access_token,
        domain: domain,
        // user: user,
        ...payload,
      });

}